import { sanitizeTimezone } from '@/lib/userTimezone';

const WEEKDAY_MAP = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

export function getLocalWeekdayIndex(timezone, at = new Date()) {
  const tz = sanitizeTimezone(timezone);
  const short = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short' }).format(at);
  return WEEKDAY_MAP[short] ?? 0;
}

export function weekdayLabel(dayIndex) {
  return (
    ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayIndex] ||
    'Unknown'
  );
}

export function isInvestDayAllowed(timezone, settings, at = new Date()) {
  if (settings?.investWeekdaysOnly === false) return { ok: true };
  const day = getLocalWeekdayIndex(timezone, at);
  const ok = day >= 1 && day <= 5;
  return {
    ok,
    day,
    reason: ok ? '' : 'invest_weekday_only',
    message: ok
      ? ''
      : 'New plan subscriptions are available Monday through Friday only (your local time).',
  };
}

export function isWithdrawDayAllowed(timezone, settings, at = new Date()) {
  if (settings?.withdrawWeekendOnly !== true) return { ok: true };
  const day = getLocalWeekdayIndex(timezone, at);
  const ok = day === 0 || day === 6;
  return {
    ok,
    day,
    reason: ok ? '' : 'withdraw_weekend_only',
    message: ok
      ? ''
      : 'Wallet withdrawals are available on Saturday and Sunday only (your local time).',
  };
}

/** Daily plan interest is credited Monday–Friday only (user local time). */
export function isInterestCreditDayAllowed(timezone, at = new Date()) {
  const day = getLocalWeekdayIndex(timezone, at);
  const ok = day >= 1 && day <= 5;
  return { ok, day };
}
